module.exports = __webpack_public_path__ + "img/third_place.e8aa5771.svg";